module.exports = __webpack_public_path__ + "static/favicon-test-2734f01a14dc10f17ac235ed2b760ae5.png";